import type { CheckboxesJSONSchema } from "../../../../types";
import { useEffect } from "react";
import Selections from "../selections";
import styles from "./styles.module.scss";
import { useBlockType } from "../../contexts/BlockTypeContext";

const MAX_OPTIONS_COUNT = 30;
const VARIANT = "checkbox";
type Props = {
  jsonSchema: CheckboxesJSONSchema;
  onChangeJsonSchema: (arg: CheckboxesJSONSchema) => void;
  gptBusy?: boolean;
};

const Checkboxes = ({ jsonSchema, onChangeJsonSchema, gptBusy }: Props) => {
  const { onChange, value } = useBlockType();

  // sanity check
  useEffect(() => {
    if (!jsonSchema?.items?.enum) {
      return onChangeJsonSchema({
        ...jsonSchema,
        uniqueItems: true,
        items: {
          type: "string",
          enum: [],
        },
      });
    }
  }, [jsonSchema, onChangeJsonSchema]);

  return (
    <Selections
      {...{ onChange, value }}
      className={styles["checkboxes"]}
      options={jsonSchema?.items.enum}
      onChangeOptions={(v) =>
        onChangeJsonSchema({
          ...jsonSchema,
          items: {
            ...jsonSchema.items,
            enum: v,
          },
        })
      }
      type={VARIANT}
      count={MAX_OPTIONS_COUNT}
      disabled={gptBusy}
    />
  );
};

export default Checkboxes;
